export const copy = (text) => {
	navigator.clipboard.writeText(text);
};